import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { ChatCopyButton } from './chat-copy-button.atom'
import { ChatPinButton } from './chat-pin-button.atom'

interface ChatMessageActionsProps {
  messageId: string
  content: string
  isPinned: boolean
  isRightAligned: boolean
  onPin?: (itemId: string) => void
}

/**
 * Action buttons (pin, copy) for a chat message.
 */
export const ChatMessageActions: FC<ChatMessageActionsProps> = ({
  messageId,
  content,
  isPinned,
  isRightAligned,
  onPin,
}): ReactNode => (
  <div className={cn('flex gap-0.5', isRightAligned ? 'flex-row-reverse' : 'flex-row')}>
    {onPin && (
      <ChatPinButton
        itemId={messageId}
        isPinned={isPinned}
        onPin={onPin}
        className="opacity-0 transition-opacity group-hover:opacity-100"
      />
    )}
    <ChatCopyButton
      content={content}
      className="opacity-0 transition-opacity group-hover:opacity-100"
    />
  </div>
)

ChatMessageActions.displayName = 'ChatMessageActions'
